import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { makeStyles } from '@material-ui/core/styles';
import makePath from 'helpers/makePath';
import * as Types from './types';
import _get from 'lodash/get';
import { matchPath } from 'react-router';

import NavListItemBase from './molecules/NavListItemBase';
import ListItemText from './molecules/ListItemText';
import ListItemIcon from './molecules/ListItemIcon';
import { NavLink } from 'react-router-dom';

interface Props {
  item: Types.InternalLinkNavItem;
  className?: string;
}

function InternalLinkNavItem({ item, className }: Props) {
  const classes = useStyles();
  const analytics = useAnalytics();
  const Icon = _get(item, 'route.Icon');
  const route = item.route;

  if (!route) {
    return null;
  }

  let navTitle = route.title;
  let path = makePath(route);

  const handleNavItemClick = () => {
    analytics.track('Main Admin Navigation Item Clicked', {
      category: 'AD - Navigation',
      label: navTitle,
    });
  };

  return (
    <NavLink
      to={path}
      activeClassName={classes.active}
      exact={route.navExact}
      onClick={handleNavItemClick}
    >
      <NavListItemBase className={className}>
        {!!Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText>{item.route && navTitle}</ListItemText>
      </NavListItemBase>
    </NavLink>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    root: {},
    active: {
      backgroundColor: theme.palette.primary.light,
      fontWeight: 700,
      color: theme.colors.white,
      '& *': {
        color: theme.colors.white,
        backgroundColor: theme.palette.primary.light,
        fontWeight: 700,
      },
    },
  };
});

export default InternalLinkNavItem;
